export default __webpack_public_path__ + "amazoniconn.88fda6.png";